export default __webpack_public_path__ + "static/BARNEYS_mobile@3x-b62ede86d6d6be07ca1cb3058dd2a3aa.png";